import React from "react";
import { KeyboardController } from "./KeyboardController/KeyboardController";
export default function Public() {
  return <KeyboardController></KeyboardController>;
}
